var path = 'components/subscribers/tooltips/accessoryNotes.html';
var html = "<div ng-repeat=\"acc in vm.displayingAccessoryNotes(subscr)\"><div>{{acc.name}}</div></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;